<template>
  <div class="holder">
    <h1>
      集合竞价专用图表
      <span @click="playIn1('biddingChart')">入场</span>
      <span @click="playOut('biddingChart')">出场</span>
    </h1>
    <bidding-Chart ref="biddingChart" id="biddingChart" customClass="c_line1" />

    <h1>
      北向资金净流入
      <span @click="playIn2('biddingChart2')">入场</span>
      <span @click="playOut('biddingChart2')">出场</span>
    </h1>
    <bidding-Chart
      ref="biddingChart2"
      id="biddingChart2"
      customClass="c_line1"
    />
  </div>
</template>
<script>
import biddingChart from "@/components/marketChart/biddingChart.vue";
import tableChart from "./tableChart.json";
export default {
  data: function () {
    return {
      fundsData: [
        {
          label: "银行",
          value: 2660,
        },
        {
          label: "证券",
          value: 1870,
        },
        {
          label: "煤炭",
          value: 166,
        },
        {
          label: "新能源",
          value: 166,
        },
        {
          label: "保险",
          value: 1870,
        },
        {
          label: "造纸",
          value: 2660,
        },
      ],
    };
  },
  components: { biddingChart },
  methods: {
    playIn1(refName) {
      this.$refs[refName].biddingChart(tableChart, {
        width: 400,
        height: 500,
        marginLeft: 30,
        marginRight: 30,
        marginTop: 50,
        marginBottom: 80,

        duration: 400,
        delay: 400,
        xPadding: 0.5,
        ease: "easeBack",
        valueSuffix: "只",
      });
    },
    playIn2(refName) {
      this.$refs[refName].northFundsIn(this.fundsData, {
        width: 400,
        height: 500,
        marginLeft: 30,
        marginRight: 30,
        marginTop: 50,
        marginBottom: 80,

        duration: 400,
        delay: 400,
        xPadding: 0.5,
        ease: "easeBack",
        valueSuffix: "只",
        title: ["净流入top3", "净流出top3"],
      });
    },

    playOut(refName) {
      this.$refs[refName].playOut();
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.holder {
  padding: 20px;
}
h1 {
  font-size: 18px;
  margin-bottom: 8px;
  font-weight: normal;
  color: #333;
  span {
    padding: 6px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    background: #999;
    color: #fff;
    user-select: none;
    margin: 0 3px;
  }
  span:nth-of-type(1) {
    background: #447746;
  }
  span:nth-of-type(2) {
    background: #953e23;
  }
}
h2 {
  font-size: 15px;
  color: #000;
  margin-bottom: 10px;
  font-weight: bold;
  .new {
    color: #fff;
    background: #f00;
    padding: 0.5rem;
    border-radius: 0.3125rem;
    margin-right: 0.625rem;
  }
}
p {
  margin-bottom: 20px;
}

.c_line1,
.c_line11 {
  margin-bottom: 20px;
  min-height: 200px;
  background: #fff;
  // background: -webkit-linear-gradient(top right, #e5884f, #e16906);
  // background: -moz-linear-gradient(top right, #e5884f, #e16906);
  // background: linear-gradient(to bottom left, #e5884f, #e16906);
  display: inline-block;
  /deep/ .axis_x,
  /deep/ .axis_y {
    .text {
      // fill: #fff;
      font-size: 14px;
    }
    .domain,
    .tick_line {
      stroke: #fff;
    }
    .tick_long_line {
      display: none;
    }
  }
  /deep/ .bar_negative {
    fill: #47e60e;
  }
  /deep/ .bar_positive {
    fill: #e62c0e;
  }

  /deep/ .value1_text_inside {
    fill: #fff;
  }

  /deep/ .value2_negative,
  /deep/ .label_out,
  /deep/ .value_out {
    fill: #47e60e;
  }

  /deep/ .value2_positive,
  /deep/ .label_in,
  /deep/ .value_in {
    fill: #e62c0e;
  }
}
</style>
